import { Action } from '@ngrx/store';
import { RuleListModel } from '../../models/RuleListModel';

export const DISABLE_RULE_SUCCESS = '[Rule] Rule Successfully Disabled';

export class DisableRuleSuccessAction implements Action {
  readonly type = DISABLE_RULE_SUCCESS;

  constructor(public payload: { rule: RuleListModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/DisableRuleSuccessAction.ts